$(document).ready(function () {
  $(".page-wrapper").css("margin-top", getNavHeight());

  $(".mobile-nav-toggle").click(function () {
    if ($(".mobile-nav").hasClass("nav-open")) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  });

  $(window).on("resize", function () {
    $(".page-wrapper").css("margin-top", getNavHeight());
    if ($(window).width() >= breakpoints.small && $(".mobile-nav").hasClass("nav-open")) {
      closeMobileNav();
    }
  });

  $(".has-sub-menu a").click(function () {
    var $submenu = $(this).parent();

    if (!$submenu.hasClass("show-sub-links")) {
      $(".has-sub-menu").removeClass("show-sub-links");
      $submenu.addClass("show-sub-links");
    } else {
      $(".has-sub-menu").removeClass("show-sub-links");
    }
  });

  // delays hiding the sub menu when leaving hover
  $(".has-sub-menu").mouseenter(function () {
    clearTimeout($(this).data('timeoutId'));
    $(".has-sub-menu").removeClass("show-sub-menu");
    $(this).addClass("show-sub-menu");
  }).mouseleave(function () {
    var hasSubMenu = $(this),
      timeoutId = setTimeout(function () {
        hasSubMenu.removeClass("show-sub-menu");
      }, 250);
    //set the timeoutId, allowing us to clear this trigger if the mouse comes back over
    hasSubMenu.data('timeoutId', timeoutId);
  });

  // control scrolled class on main nav
  if($(".page-wrapper").length && $("nav").length) {
    var bodyWaypoint = new Waypoint({
      element: $(".page-wrapper"),
      handler: function (direction) {
        if (direction === "down") $("nav").addClass("scrolled");
        if (direction === "up") $("nav").removeClass("scrolled");
      },
      offset: function () {
        return getNavHeight() - 1;
      }
    });
  }
});

function openMobileNav() {
  $(".mobile-nav").addClass("nav-open");
  window.tempScrollTop = $(window).scrollTop();
  $('body').css('position', 'fixed');
}

function closeMobileNav() {
  $(".mobile-nav").removeClass("nav-open");
  $(".has-sub-menu").removeClass("show-sub-links");
  $('body').css('position', 'static');
  $(window).scrollTop(window.tempScrollTop);
}

function getNavHeight() {
  if ($(window).width() > breakpoints.small) {
    var mainNavHeight = $(".desktop-nav").height();
    var subNavHeight = $(".has-sub-menu.active .sub-menu").height() || 0;
    return mainNavHeight + subNavHeight - 1;
  } else {
    return $("nav").height() - 1;
  }
}